module.exports = __webpack_public_path__ + "static/media/homeLogo.237a8885.png";